import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-support',
    templateUrl: './support.component.html',
    styleUrls: ['./support.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SupportComponent {

}